import React from 'react';
import { observer } from 'mobx-react';

import { RootStoreContext } from '../../../../../../context';

export default Component => {
    @observer
    class withGetResourceDetails extends React.Component {
        
        static contextType = RootStoreContext;
        
        render () {
            return (
                <Component
                    getResourceDetails={this.context.privateMessagingStore.conversationSession.session.getResourceDetails}
                    {...this.props}
                />
            );
        }
    }
    return withGetResourceDetails;
}
